export const convertSecondsToTwentyFourHourTime = (seconds: number) => {
  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  return { hour: hours, minute: minutes }
}
